"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.interactionSelectorCache = exports.CLICK_ACTION_MAX_DURATION = void 0;
exports.getInteractionSelector = getInteractionSelector;
exports.updateInteractionSelector = updateInteractionSelector;
const browser_core_1 = require("@datadog/browser-core");
// Maximum duration for click actions
exports.CLICK_ACTION_MAX_DURATION = 10 * browser_core_1.ONE_SECOND;
exports.interactionSelectorCache = new Map();
function getInteractionSelector(relativeTimestamp) {
    const selector = exports.interactionSelectorCache.get(relativeTimestamp);
    exports.interactionSelectorCache.delete(relativeTimestamp);
    return selector;
}
function updateInteractionSelector(relativeTimestamp, selector) {
    exports.interactionSelectorCache.set(relativeTimestamp, selector);
    exports.interactionSelectorCache.forEach((_, relativeTimestamp) => {
        if ((0, browser_core_1.elapsed)(relativeTimestamp, (0, browser_core_1.relativeNow)()) > exports.CLICK_ACTION_MAX_DURATION) {
            exports.interactionSelectorCache.delete(relativeTimestamp);
        }
    });
}
//# sourceMappingURL=interactionSelectorCache.js.map